// import api from "@/api/index";

export const state = {
  loading: false
};

export const getters = {};

export const actions = {};

export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading;
  }
};
